import LegalLayout from "./Legallayout";
import { TERMS_AND_CONDITIONS } from "./Legaldata";

export default function TermsAndConditions() {
  return <LegalLayout doc={TERMS_AND_CONDITIONS} />;
}